module.exports = __webpack_public_path__ + "img/template1.b59fca4d.png";